export class RegexValidator {
    matchPattern = (string, pattern) => {
        if (string && pattern) {
            return new RegExp(pattern).test(string);
        }

        return true;
    };
}
